export const administrationFr = {}
